import "@fontsource/noto-sans";
import "@fontsource/source-sans-pro";
import "@fontsource/source-sans-pro/700.css";
export const normal = 400;
export const bold = 700;
